import { FC, useContext, useEffect, useState } from 'react';

import { H2, Preloader } from '@smartshell/ui-kit';
import { Cell, Pie, PieChart } from 'recharts';

import { LocalizationContext } from 'localization';
import { IBonusDetailedSummaryReport } from 'schemas';

import { CenterContent } from './components';
import { COLORS } from './constants';
import { ISourceBonusProps } from './interfaces';
import s from './SourceBonus.module.scss';

export const SourceBonus: FC<ISourceBonusProps> = ({ report, loading }) => {
  const { t } = useContext(LocalizationContext);
  const [animated, setAnimated] = useState(true);

  const getSourceChartData = (
    report: IBonusDetailedSummaryReport,
    t: (key: string) => string
  ): { name: string; value: number }[] => {
    const values = report.data?.[0]?.values || [];
    const labels = report.labels || [];

    const labelMap: Record<string, string> = {
      cashback: 'Кешбек',
      'key.bonus_manager': 'Прямые начисления',
      'nav.achievements': 'Достижения',
      'nav.promo': 'Промокоды',
    };

    return Object.entries(labelMap).map(([translationKey, backendLabel]) => {
      const index = labels.indexOf(backendLabel);
      return {
        name: t(translationKey),
        value: index >= 0 ? values[index] || 0 : 0,
      };
    });
  };

  const summary = report?.bonusDetailedSummaryReport;
  const data = summary?.data?.length
    ? getSourceChartData(summary, t as (key: string) => string)
    : [];

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimated(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={s.container}>
      <H2>{t('report.bonus.source')}</H2>

      {loading ? (
        <Preloader loading />
      ) : !data.length ? (
        <div className={s.placeholder}>
          {t('transfers.notData.placeholder')}
        </div>
      ) : data.every((item) => item.value === 0) ? (
        <div className={s.placeholder}>{t('visitors.empty.data')}</div>
      ) : (
        <div className={s.chart}>
          <PieChart width={482} height={482}>
            <Pie
              data={data}
              cx={238}
              cy={238}
              startAngle={90}
              endAngle={-270}
              innerRadius={180}
              outerRadius={238}
              fill="#8884d8"
              paddingAngle={1}
              dataKey="value"
              cornerRadius={8}
              isAnimationActive={animated}
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  stroke="var(--bg-item-primary)"
                />
              ))}
            </Pie>
          </PieChart>

          <CenterContent data={data} />
        </div>
      )}
    </div>
  );
};
